import styled from 'styled-components';
import { PageMeta, PageMetaValue, PageTitle } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';
import BuildingIcon from '@/assets/icons/companyIcon.svg?react';
import InfoGreyIcon from '@/assets/icons/infogrey.svg?react';

export const ReportDetailsCont = styled.div`
  position: relative;
  flex-grow: 1;
  width: 1160px;
  align-self: center;
  display: flex;
  flex-direction: column;
  ${({ theme }: IThemeProvider) => `
    @media ${theme.layout.breakpoints.max.desktop} {
      width: 900px;
    }
    @media ${theme.layout.breakpoints.max.tablet} {
      width: 400px;
    }
  `}
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;

  #DownloadButtonCont {
    position: static;
  }
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

export const ReportDetailsWrapper = styled.div`
  position: relative;
  padding: 0 24px;
`;

export const ReportName = styled(PageTitle)`
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const DetailsCont = styled(PageMeta)``;

export const DetailCont = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
`;

export const CompanyIcon = styled(BuildingIcon)`
  width: 14px;
  height: 14px;

  path {
    ${({ theme }: IThemeProvider) => `
      fill: ${theme.colors.neutral.primary[60]};
    `}
  }
`;

export const BoldedText = styled(PageMetaValue)``;

export const ReportType = styled(BoldedText)`
  text-transform: capitalize;
`;

export const ResponseRateCont = styled.div`
  display: inline-flex;
`;

export const TooltipCont = styled.div`
  display: inline-flex;
  align-items: center;
  text-align: justify;
  cursor: help;
`;

export const InfoIcon = styled(InfoGreyIcon)`
  path {
    ${({ theme }: IThemeProvider) => `
    fill: ${theme.colors.neutral.primary[80]};
`}
  }
`;

export const SpinnerCont = styled.div`
  position: fixed;
  z-index: 1;
  top: 50%;
  left: 50%;

  .ant-spin-dot {
    font-size: 60px;

    .ant-spin-dot-item {
      width: 23.83px;
      height: 23.83px;
    }
  }
`;
